/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const conversationPriorityEnum = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export type ConversationPriorityEnumKey =
  (typeof conversationPriorityEnum)[keyof typeof conversationPriorityEnum];

export type ConversationPriority = ConversationPriorityEnumKey;
